// extracted by mini-css-extract-plugin
export default {"switchContainer":"ScaleAdminTable_switchContainer__0vRcg","rowContainer":"ScaleAdminTable_rowContainer__BH6t5"};